import { create, tsx } from '@dojo/framework/core/vdom';
import { Link } from '@dojo/framework/routing/Link';
import { Head } from './Head';
import { Hero } from './Hero';
import { jobs, Section } from './pages/careers/jobs';

import * as css from './JobPost.m.css';
import * as commonCss from '../Common.m.css';
import * as connectButtonCss from './ConnectButton.m.css';

export interface JobPostProperties {
	id: string;
}

function content(section: Section) {
	return (
		<virtual>
			{section.text && <p>{section.text}</p>}
			{section.points && (
				<ul classes={css.list}>
					{section.points.map((point) => (
						<li>{point}</li>
					))}
				</ul>
			)}
		</virtual>
	);
}
const factory = create().properties<JobPostProperties>();

export const JobPost = factory(function JobPost({ properties }) {
	const { id } = properties();
	const job = jobs.find((job) => job.route === id);

	if (!job) {
		return;
	}

	const { name, title, description, type, sections } = job;
	const mailtoUrl = `mailto:careers@sitepen.com?subject=Job Application: ${name}`;

	return (
		<div classes={css.root}>
			<Head title={title} description={description} />

			<div classes={css.heroWrapper}>
				<div classes={commonCss.contentWrapper}>
					<Hero>
						{{
							title: type,
							xlTitle: name,
							subtitle: 'Remote'
						}}
					</Hero>
				</div>
			</div>

			<div classes={commonCss.smallerContentWrapper}>
				<p>
					<Link to="careers">‹ Back to Careers</Link>
				</p>

				{sections.map((section) => {
					if (section.title) {
						return (
							<section classes={css.section}>
								<h3 classes={css.h3}>{section.title}</h3>
								{content(section)}
							</section>
						);
					} else {
						return content(section);
					}
				})}

				<section classes={css.section}>
					<h3 classes={css.h3}>Job Location</h3>

					<p>
						You'll work at home! Your home just needs to be somewhere within the United
						States.
					</p>
				</section>

				<section classes={css.section}>
					<h3 classes={css.h3}>To Apply</h3>

					<p>
						To be considered for this role, please{' '}
						<a href={mailtoUrl}>send us an email</a> that includes your resume, cover
						letter and relevant work samples. Thank you!
					</p>
					<a href={mailtoUrl} classes={[connectButtonCss.root, connectButtonCss.cta]}>
						Apply Now
					</a>
				</section>
			</div>
		</div>
	);
});

export default JobPost;
